/**
 * The Setup page's ticks and the organisation's saved checklist (#6708).
 *
 * The page thinks in two lookups (step id -> ticked, sub-step id -> ticked);
 * the organisation keeps two id lists. These two functions are the whole
 * translation, so the page never touches the saved shape directly.
 */
import type { SetupChecklist } from '@/lib/types';

export type SetupTicks = {
  checked: Record<string, boolean>;
  childChecked: Record<string, boolean>;
};

const asLookup = (ids: string[] | undefined): Record<string, boolean> =>
  Object.fromEntries((ids ?? []).map((id) => [id, true]));

export function ticksFromChecklist(checklist: SetupChecklist | null | undefined): SetupTicks {
  return { checked: asLookup(checklist?.steps), childChecked: asLookup(checklist?.children) };
}

const tickedIds = (lookup: Record<string, boolean>): string[] =>
  Object.entries(lookup)
    .filter(([, ticked]) => ticked)
    .map(([id]) => id);

export function checklistFromTicks(ticks: SetupTicks): SetupChecklist {
  return { steps: tickedIds(ticks.checked), children: tickedIds(ticks.childChecked) };
}
